










import Vue from "vue";
import Component from "vue-class-component";
import { AtendimentoService } from "@/services/atendimento.service";
import { Prop, Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value: string | null;
}

@Component
export default class ComboUsarioResponsavel extends Vue {
  @Prop() readonly value!: number | null;
  @Prop() readonly validacao!: [] | null;
  @Prop({ default: false }) readonly campoVazio!: boolean | null;

  loading = false;
  tipo: ComboItem | null = null;
  itemsTipo: ComboItem[] = [];

  @Watch("value")
  onValueChange(val: string | null) {
    this.tipo = this.itemsTipo.find((x) => x.value == val) ?? this.itemsTipo[0];
  }

  @Watch("tipo")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }

  async fetchUsuarioResponsavel() {
    this.loading = true;
    const res = await AtendimentoService.ObterUsuarios();

    this.itemsTipo = res.map((x) => ({
      text: x.nome,
      value: "" + x.idUsuario,
    }));

    if (!this.campoVazio) {
      this.itemsTipo.unshift({ text: "", value: null });
    }

    if (this.value) {
      this.tipo = this.itemsTipo.find((x) => x.value == this.value) || null;
    }

    this.loading = false;
  }

  mounted() {
    this.fetchUsuarioResponsavel();
    // this.setUsuarioLogado();
  }

  // async setUsuarioLogado() {
  //   const retorno = (await AtendimentoService.ObterUsuarioLogado()).toString();
  //   this.tipo =
  //     this.itemsTipo.find((x) => x.value == retorno) ?? this.itemsTipo[0];
  // }
}
